import { StyleType } from '../types';

export const style: StyleType = `
.p-radiobutton-group {
    display: inline-flex;
}
`;
